import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    console.log('[API] error interceptor:', error.response?.status, originalRequest.url);
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      console.log('[API] attempting token refresh...');
      try {
        await axios.post(
          `${api.defaults.baseURL}/auth/refresh/`,
          {},
          { withCredentials: true }
        );
        console.log('[API] refresh succeeded, retrying original request');
        return api(originalRequest);
      } catch {
        console.log('[API] refresh failed');
        // Don't redirect here — let React's ProtectedRoute handle it
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
